<template>
	<v-row>
		<v-col>
			<macro-file-list />
		</v-col>
	</v-row>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({});
</script>
